<template>
  <v-container class="trialPage mt-0">
      <v-layout row wrap justify-center v-if="loading">
        <v-flex xs12 sm10 md10 class="text-xs-center">
          <v-progress-circular
          indeterminate
          color="primary"
          :width="7"
          :size="70"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    <v-layout row v-else>
      <v-flex xs12 sm10 offset-sm1 class="text-xs-center mb-4" justify-center align-center>
        <h1 class="mt-3 mb-4 text-xs-center trialtitle">
          <div class="status"><span :class="enrollmentsss.enrollmentName"></span></div>
          <span>{{ trial.trialName }}</span>
          <!-- <template v-if="userIsAuthenticated">
            <app-edit-trial-details-dialog :trial="trial"></app-edit-trial-details-dialog>
          </template> -->
        </h1>
        <div class="trialData">
            <div slot="header" class="header"><document-icon class="icon mr-2"></document-icon>Description</div>
            <v-card>
              <v-card-text class="white pl-4 pr-4">
                <pre class="textDescription">{{ trial.trialDescription }}</pre>
              </v-card-text>
              <v-divider></v-divider>
              <!-- <v-card-text class="cyanLight editDialogsRow" v-if="userIsAuthenticated">
                  <template v-if="userIsAuthenticated">
                    <v-spacer></v-spacer>
                    <app-edit-trial-details-dialog :trial="trial"></app-edit-trial-details-dialog>
                  </template>
              </v-card-text> -->
            </v-card>
        </div>
        <div class="trialData">
            <div slot="header" class="header"><person-icon class="icon mr-2" />Coordinators</div>
            <v-card>
              <v-card-text class="white pa-2">
                <v-list>
                  <v-list-tile v-for="(item, index) in coordinatorsGetter" v-bind:key="`item-${index}`">
                    <v-list-tile-content>
                      {{ item.coordinatorName }}
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn icon ripple :href="'tel:' + item.coordinatorPhone">
                        <v-icon v-bind:color="item.active ? 'primary' : 'grey lighten-2'">phone</v-icon>
                        <!--<phoneIcon class="icon" />-->
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action>
                      <v-btn icon ripple :href="'sms:' + item.coordinatorPhone">
                        <v-icon v-bind:color="item.active ? 'primary' : 'grey lighten-2'">textsms</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action>
                      <v-btn icon ripple :href="'mailto:' + item.coordinatorEmail + '?subject=' + trial.trialName">
                        <v-icon v-bind:color="item.active ? 'primary' : 'grey lighten-2'">email</v-icon>
                        <!--<emailIcon class="icon" />-->
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-card-text>
              <v-divider></v-divider>
              <!-- <v-card-text class="cyanLight editDialogsRow" v-if="userIsAuthenticated">
                  <template v-if="userIsAuthenticated">
                    <v-spacer></v-spacer>
                    <app-edit-trial-coordinators-dialog :trial="trial"></app-edit-trial-coordinators-dialog>
                  </template>
              </v-card-text> -->
            </v-card>
        </div>
        <div class="trialData">
            <div slot="header" class="header"><v-icon color="primary" class="mr-2">person_outline</v-icon>Investigators</div>
            <v-card>
              <v-card-text class="white pa-2">
                <v-list>
                  <v-list-tile v-for="(item, index) in investigatorsGetter" v-bind:key="`item-${index}`">
                    <v-list-tile-content>
                      {{ item.investigatorName }}
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn icon ripple :href="'tel:' + item.investigatorPhone">
                        <v-icon v-bind:color="item.active ? 'primary' : 'grey lighten-2'">phone</v-icon>
                        <!--<phone-icon class="icon" />-->
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action>
                      <v-btn icon ripple :href="'sms:' + item.investigatorPhone">
                        <v-icon v-bind:color="item.active ? 'primary' : 'grey lighten-2'">textsms</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action>
                      <v-btn icon ripple :href="'mailto:' + item.investigatorEmail + '?subject=' + trial.trialName + '&body=Name: <br>Tel: <br>Email: '">
                        <v-icon v-bind:color="item.active ? 'primary' : 'grey lighten-2'">email</v-icon>
                        <!--<email-icon class="icon" />-->
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-card-text>
              <v-divider></v-divider>
              <!-- <v-card-text class="cyanLight editDialogsRow" v-if="userIsAuthenticated">
                  <template v-if="userIsAuthenticated">
                    <v-spacer></v-spacer>
                    <app-edit-trial-investigators-dialog :trial="trial"></app-edit-trial-investigators-dialog>
                  </template>
              </v-card-text> -->
            </v-card>
        </div>
        <div class="trialData">
            <div slot="header" class="header"><map-icon class="icon mr-2" />Address</div>
            <v-card>
              <v-card-text class="white pl-4 pr-4" v-for="item in locationsss" v-bind:key="item.locationID">
                <strong>{{ item.locationName }}</strong><br>
                {{ item.locationStreetAddress }}<br>
                {{ item.locationCity }}, {{ item.locationState }} {{ item.locationZipcode }}
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
        </div>
        <div class="trialData">
            <div slot="header" class="header"><map-icon class="icon mr-2" />Location</div>
            <v-card>
              <v-card-text class="white pl-4 pr-4" v-if="trial.trialLocations" v-for="(item, index) in locationsss" v-bind:key="`item-${index}`">
                {{ item.locationName }}<br>
                <!--<div v-if="index == trial.trialLocations.length - 1">
                  <template v-if="userIsCreator">
                    <v-spacer></v-spacer>
                    <app-edit-trial-locations-dialog :trial="trial"></app-edit-trial-locations-dialog>
                  </template>
                </div>-->
              </v-card-text>
              <v-divider></v-divider>
              <!-- <v-card-text class="cyanLight editDialogsRow" v-if="userIsAuthenticated">
                  <template v-if="userIsAuthenticated">
                    <v-spacer></v-spacer>
                    <app-edit-trial-locations-dialog :trial="trial"></app-edit-trial-locations-dialog>
                  </template>
              </v-card-text> -->
            </v-card>
        </div>
        <div class="trialData">
          <div slot="header" class="header"><indication-icon class="icon mr-2" />Indications</div>
          <v-card>
            <v-card-text class="white pl-4 pr-4" v-for="(item, index) in indicationsss" v-bind:key="`item-${index}`">
              {{ item.indicationName }}<br>
            </v-card-text>
            <v-divider></v-divider>
            <!-- <v-card-text class="cyanLight editDialogsRow" v-if="userIsAuthenticated">
                <template v-if="userIsAuthenticated">
                  <v-spacer></v-spacer>
                  <app-edit-trial-indications-dialog :trial="trial"></app-edit-trial-indications-dialog>
                </template>
            </v-card-text> -->
          </v-card>
        </div>
        <v-btn depressed class="mt-4 alt--text text--darken-3" color="alt lighten-5" dark :href="trial.trialLink" target="_blank">ClinicalTrials.gov</v-btn>
        <v-btn v-if="userIsAuthenticated" depressed class="mt-4 white--text" color="primary lighten-5" dark :to="'/trials/' + trial.trialId + '/edit'">Edit</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import * as firebase from 'firebase'

export default {
  data () {
    return {
    //  dialog: false
    }
  },
  props: ['id'],
  computed: {
    trial () {
      console.log(this.id)
      return this.$store.getters.loadedTrial(this.id)
    },
    enrollments () {
      return this.$store.getters.loadedEnrollments
    },
    enrollmentsss () {
      if (this.trial.trialEnrollment) {
        var val = []
        val = this.$store.getters.loadedEnrollment(this.trial.trialEnrollment)
        console.log('enrollmentsss val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    },
    locations () {
      return this.$store.getters.loadedLocations
    },
    locationsss () {
      if (this.trial.trialLocations) {
        var indis = []
        var val = []
        // var item = []
        this.trial.trialLocations.filter(function (elem) {
          indis.push(elem)
        })
        console.log('Location IDs: ' + JSON.stringify(indis))
        for (let i = 0; i < indis.length; i++) {
          console.log('SECOND GET INDIS: ' + JSON.stringify(this.$store.getters.loadedLocation(indis[i])))
          if (this.$store.getters.loadedLocation(indis[i])) {
            val.push(this.$store.getters.loadedLocation(indis[i]))
          }
        }
        console.log('FINAL val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    },
    indications () {
      return this.$store.getters.loadedIndications
    },
    indicationsss () {
      if (this.trial.trialIndications) {
        var indis = []
        var val = []
        // var item = []
        this.trial.trialIndications.filter(function (elem) {
          indis.push(elem)
        })
        console.log('Indication IDs: ' + JSON.stringify(indis))
        for (let i = 0; i < indis.length; i++) {
          console.log('SECOND GET INDIS: ' + JSON.stringify(this.$store.getters.loadedIndication(indis[i])))
          if (this.$store.getters.loadedIndication(indis[i])) {
            val.push(this.$store.getters.loadedIndication(indis[i]))
          }
        }
        console.log('FINAL val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    },
    investigator () {
      return this.$store.getters.loadedInvestigators
    },
    investigatorsGetter () {
      if (this.trial.trialInvestigators) {
        var indis = []
        var val = []
        // var item = []
        this.trial.trialInvestigators.filter(function (elem) {
          indis.push(elem)
        })
        console.log('Investigator IDs: ' + JSON.stringify(indis))
        for (let i = 0; i < indis.length; i++) {
          console.log('SECOND GET Investigator: ' + JSON.stringify(this.$store.getters.loadedInvestigator(indis[i])))
          if (this.$store.getters.loadedInvestigator(indis[i])) {
            val.push(this.$store.getters.loadedInvestigator(indis[i]))
          }
        }
        console.log('FINAL val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    },
    coordinator () {
      return this.$store.getters.loadedCoordinators
    },
    coordinatorsGetter () {
      if (this.trial.trialCoordinators) {
        var indis = []
        var val = []
        // var item = []
        this.trial.trialCoordinators.filter(function (elem) {
          indis.push(elem)
        })
        console.log('Coordinator IDs: ' + JSON.stringify(indis))
        for (let i = 0; i < indis.length; i++) {
          console.log('SECOND GET Coordinator: ' + JSON.stringify(this.$store.getters.loadedCoordinator(indis[i])))
          if (this.$store.getters.loadedCoordinator(indis[i])) {
            val.push(this.$store.getters.loadedCoordinator(indis[i]))
          }
        }
        console.log('FINAL val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsCreator () {
      if (!this.userIsAuthenticated) {
        return false
      }
      return this.$store.getters.user.id === this.trial.creatorId
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>

<style lang="scss">
.trialPage{
  .trialtitle{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .trialData{
    .list__tile__action{
      min-width: 36px;
    }
    .textDescription{
      white-space: pre-line;
      font-family: 'Roboto', sans-serif;
      font-size: 16px;
      line-height: 24px;
    }
  }
  div.status{
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 15px;
    span{
      height: 15px;
      width: 15px;
      border-radius: 15px;
      &.Enrolling{
        background: green;
      }
      &.Not.Enrolling{
        background: red;
      }
      &.Pending {
        background: orange;
      }
    }
  }
  .card__text{
    border-bottom: 2px solid #eeeeee !important;
  }
  .editDialogsRow{
    .card__text{
      border-bottom: none !important;
    }
  }
  .expansion-panel__body{
    margin-bottom: 0.5em;
    .list{
      padding: 0 !important;
      .list__tile{
        padding: 0 !important;
      }
    }
  }
}
.expansion-panel__header{
  background: #f7f1e3 !important;
}
  .header .icon{
    color: #cba349 !important;
  }


</style>



// WEBPACK FOOTER //
// Trial.vue?4033146f